import screenAndStyle from './screen-and-style';

function isDataURL(url) {
  return /^(blob|data):/.test(url);
}

function isEL2(url) {
  return /\/el2\//.test(url);
}

function _setURL(src, callback, reportError) {
  // XMLHttpRequest.responseURL is not currently supported by IE11: Early exit
  if (isDataURL(src) || screenAndStyle.isInternetExplorer()) {
    return callback(src);
  }

  if (isEL2(src)) {
    // Work around annoying Chrome bug that sets invalid Origin header
    // on redirect
    const xhr = new XMLHttpRequest();
    xhr.open('HEAD', src);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          callback(xhr.responseURL ? xhr.responseURL : src);
        } else {
          console.error(`Unable to get source URL for ${src.toString()}`);
          if (reportError) {
            reportError({ url: src, status: xhr.status });
          }
          callback(src); // just in case it works
        }
      }
    };
    xhr.onerror = function () {
      // Ignore and try original anyway.
      callback(src);
    };
    xhr.send();
  } else {
    callback(src);
  }
}

function fetchImage(src, crossOrigin, handleLoad, handleError) {
  const image = new Image();

  if (!(screenAndStyle.isSafari() && isDataURL(src))) {
    image.crossOrigin = crossOrigin;
  }

  image.onload = handleLoad;
  image.onerror = handleError;

  _setURL(src, setImageSrc, handleError);

  function setImageSrc(src) {
    if (src.match(/^\/\/prism(-testing|-staging)?-wm.livelink.io/)) {
      src = `https:${src}`;
    }
    // The use of createObjectURL is a fix around IE11 deficiencies
    // http://stackoverflow.com/a/19734516
    if (screenAndStyle.isInternetExplorer() && isEL2(src) && !isDataURL(src)) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', src, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (this.status === 200) {
          image.src = (window.URL || window.webkitURL).createObjectURL(this.response);
        }
      };
      xhr.onerror = function () {
        image.src = src;
      };
      xhr.send();
    } else {
      image.src = src;
    }
  }

  return image;
}

export default fetchImage;
